import React, { Component } from "react";

import ErrorBoundary from "components/common/ErrorBoundary";
import { FeedItemComments } from "components/Comments";

import FeedItemPreview from "./feed-item/Preview";
import FeedItemFooter from "./feed-item/Footer";
import UserActivityHeader from "./feed-item/UserActivityHeader";
import RecognitionCreatedPreview from "./feed-item/RecognitionCreatedPreview";

const usesEntityComments = item => (
  ["recognition_created", "photo_created", "event_created"].includes(item.activityType)
);

class FeedItem extends Component {
  constructor(props) {
    super(props);

    const { item } = props;
    const { commentCount } = usesEntityComments(item) ? item.entity : item;

    this.state = { showComments: commentCount > 0 };
  }

  handleCommentClick = () => {
    this.setState(({ showComments }) => ({ showComments: !showComments }));
  };

  handleCommentsChange = commentCount => {
    const { item, onUserActivityUpdate } = this.props;

    let mutation;
    if (usesEntityComments(item)) {
      mutation = { entity: { ...item.entity, commentCount } };
    } else {
      mutation = { commentCount };
    }

    onUserActivityUpdate({ userActivityId: item.id, updates: mutation });
  };

  handlePhotoCheerToggle = (photoId, cheerForUser, cheersCount) => {
    const { item, onUserActivityUpdate } = this.props;

    if (item.entity.id === photoId) {
      onUserActivityUpdate({
        userActivityId: item.id,
        updates: {
          entity: { ...item.entity, cheerForUser, cheersCount }
        }
      });
    }
  };

  handleStoryCheerToggle = (storyId, cheerForUser, cheersCount) => {
    const { item, onUserActivityUpdate } = this.props;

    if (item.entity.id === storyId) {
      onUserActivityUpdate({
        userActivityId: item.id,
        updates: {
          entity: { ...item.entity, cheerForUser, cheersCount }
        }
      });
    }
  };

  handleSurveyComplete = () => {
    const { item, onUserActivityUpdate } = this.props;

    onUserActivityUpdate({
      userActivityId: item.id,
      updates: {
        entity: {
          ...item.entity,
          responseCount: item.entity.responseCount + 1,
          statusForUser: "complete"
        }
      }
    });
  };

  render() {
    const { animateIn, item, noComments, onUserActivityUpdate, onUserActivityRemove } = this.props;
    const { showComments } = this.state;

    if (item.activityType === "recognition_created") {
      return (
        <RecognitionCreatedPreview
          item={item}
          onUserActivityUpdate={onUserActivityUpdate}
        />
      );
    }

    return (
      <div className={`FeedItem ${animateIn ? "fadeIn" : ""}`}>
        <div className="FeedItem__preview">
          <ErrorBoundary>
            <UserActivityHeader userActivity={item} />
            <FeedItemPreview
              item={item}
              onPhotoCheerToggle={this.handlePhotoCheerToggle}
              onStoryCheerToggle={this.handleStoryCheerToggle}
              onSurveyComplete={this.handleSurveyComplete}
              onUserActivityUpdate={onUserActivityUpdate}
              onUserActivityRemove={onUserActivityRemove}
            />
          </ErrorBoundary>
        </div>
        <FeedItemFooter
          item={item}
          noComments={noComments}
          onCommentsClick={this.handleCommentClick}
        />

        {!noComments && showComments && (
          <div className="FeedItem__comments">
            <FeedItemComments item={item} onChange={this.handleCommentsChange} />
          </div>
        )}
      </div>
    );
  }
}

export default FeedItem;
